import { Currency, Locale } from '@nemuru-eng/js-api-client';

import { LANGUAGES } from '../../../../../config/languages';
import { useConfigContext } from '../../../../../contexts/ConfigContext/ConfigContext';
import { LANGUAGE_PARAMS } from '../constants/LanguageParams';

export const LANGUAGE_COOKIE_NAME = 'language';

export const useLanguages = () => {
  const { actions } = useConfigContext();

  const setLanguageInApp = (language) => {
    localStorage.setItem(LANGUAGE_COOKIE_NAME, language);
    actions.setLanguage(language);
  };

  const getCurrencyByLocale = (locale?: Intl.Locale) => {
    if (locale === new Intl.Locale(Locale.ES_MX)) {
      return Currency.MXN;
    }
    return Currency.EUR;
  };

  const getRegionByLanguage = (language) => {
    if (language) return LANGUAGE_PARAMS[language].region;
    return LANGUAGE_PARAMS[LANGUAGES.spanish].region;
  };

  const setLanguageAndRegionInContext = (language, region) => {
    if (!region) getRegionByLanguage(language);
    try {
      actions.setRegion(region);
      setLanguageInApp(language);
    } catch (error) {
      actions.setLanguage(language);
    }
  };

  const setLanguageByUrlParam = (language = LANGUAGES.spanish) => {
    const queryParams = new URLSearchParams(location.search);
    const languageCookie = localStorage.getItem(LANGUAGE_COOKIE_NAME);
    if (queryParams.has('locale')) {
      const localeByParams = queryParams.get('locale');
      const formattedLocale = localeByParams?.replace('_', '-');
      const locale = formattedLocale ? new Intl.Locale(formattedLocale) : undefined;
      let language = locale?.language;
      let region = locale?.region;
      const isLanguageValid = Object.values(LANGUAGES).some((allowedLanguage) => allowedLanguage === language);
      if (!isLanguageValid) {
        language = LANGUAGES.spanish;
        region = LANGUAGE_PARAMS[LANGUAGES.spanish].region;
      }
      actions.setLocaleCurrency(getCurrencyByLocale(locale));
      setLanguageAndRegionInContext(language, region);
      return;
    }
    if (languageCookie) {
      const region = getRegionByLanguage(languageCookie);
      setLanguageAndRegionInContext(languageCookie, region);
      return;
    }
    setLanguageAndRegionInContext(language, LANGUAGE_PARAMS[language].region);
  };

  return { setLanguageByUrlParam, setLanguageInApp };
};
